import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { translate } from "react-admin";
import { Form, Field, reduxForm, blur, touch } from "redux-form";
import { renderTextField } from "./inputs/renderMaterialFields";
import { required } from "./inputs/validator";
import { Typography } from "@material-ui/core";
import withMobileDialog from "@material-ui/core/withMobileDialog";

const styles = {
  errorMsg: {
    color: "#CB5D58",
    marginTop: "10px"
  },
  msg: {
    marginTop: "10px"
  }
};

let DeletePopup = props => {
  const { handleDelete, handleClose, open, errorMessage, fullScreen } = props;
  const checkAndSubmit = () => {
    handleDelete();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {props.translate("resources.users.deleteDialog.header")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="p" component="p" style={styles.msg}>
            {props.translate("resources.users.deleteDialog.reallyDelete")}
          </Typography>

          {errorMessage && (
            <Typography variant="p" component="p" style={styles.errorMsg}>
              {props.translate(errorMessage)}
            </Typography>
          )}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} style={{ color: "#4F6982" }}>
          {props.translate("resources.users.deleteDialog.cancel")}
        </Button>
        <Button
          style={{ color: "#4F6982" }}
          onClick={checkAndSubmit}
          color="primary"
        >
          {props.translate("resources.users.deleteDialog.doDelete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeletePopup.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string
};

export default translate(connect()(withMobileDialog()(DeletePopup)));
